import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { LOGIN_PATH } from '../../shared/utility';

class Logout extends Component {
    
    componentDidMount() {
        this.props.onLogout();
        setTimeout(()=>{
            window.location.reload(false);
        },1000)
    }
    render(){
        // Not "/": that is the customer home page now.
        return <Redirect to={LOGIN_PATH}/>;
    }
}


const mapDispatchToProps = dispatch => {
    return {
        onLogout : () => dispatch(actions.logout())
    }
}

export default withRouter(connect(null,mapDispatchToProps)(Logout));